<template>
  <div class="box">
    <div class="main-content">
      <!-- 课次列表部分开始 -->
      <div class="classTimesList">
        <!-- 输入课次搜索框 -->
        <div class="courseSearch-content">
          <div class="courseSearch-box flex align spaceBetween">
            <input v-model="courseName" @keyup.enter="courseSearch(courseName)" class="courseSearch" type="text"
              placeholder="输入课次名称" />
            <img @click="courseSearch(courseName)" class="searchIcon pointer"
              src="../../assets/resourceManagement/searchIcon.png" />
          </div>
        </div>
        <!-- 课次列表标题 -->
        <div class="classTimesList-title-box flex align">
          <div class="classTimesList-block"></div>
          <div class="classTimesList-title">课次列表</div>
        </div>
        <!-- 全部课次 -->
        <div @click="allClasses" :class="currentClassesIdx == -1 ? 'allClasses' : 'classList'">
          <div class="classList-circle"></div>
          <div class="classList-num">全部课次</div>
        </div>
        <!-- 课次列表 -->
        <div class="classList-box">
          <div @click="singleClass(index)" :class="currentClassesIdx == index ? 'allClasses' : 'classList'"
            v-for="(item, index) in allListClasses" :key="index">
            <div class="classList-circle"></div>
            <div class="classList-num">课次{{ index + 1 }}</div>
            <div class="classList-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <!-- 课次列表部分结束 -->
      <!-- 资源库 习题库 作业库部分 -->
      <div class="resourcesList">
        <div class="libraryListTop">
          <!-- 资源库 -->
          <div @click="libraryList('assets')" class="libraryList-box">
            <img class="resourcePool" :src="blueResourcePool" />
          </div>
          <!-- 习题库 -->
          <div @click="libraryList('examitem')" class="libraryList-box"
            style="border-left: 1px solid #bfbfbf; border-right: 1px solid #bfbfbf">
            <img class="exercisebank" :src="greyExercisebank" />
          </div>
          <!-- 作业库 -->
          <div @click="libraryList('exam')" class="libraryList-box">
            <img class="testpaperlibrary" :src="greyTestpaperlibrary" />
          </div>
        </div>
        <div class="resourcesContent flex column spaceBetween">
          <div class="flex align spaceBetween" style="width: 100%;">
            <div class="inputSearch-box">
              <input v-model="resourceName" @keyup.enter="resourceSearch(resourceName)" class="inputSearch" type="text"
                placeholder="输入资源名称" />
              <img @click="resourceSearch(resourceName)" class="searchIcon pointer"
                src="../../assets/resourceManagement/searchIcon.png" />
            </div>
            <el-select v-if="this.$route.params.method" @change="changeCourseOptions" v-model="courseId"
              placeholder="请选择课程">
              <el-option v-for="item in courseOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <div class="resourceFunction flex align spaceBetween">
              <!-- 资源库功能区部分开始 -->
              <div v-show="resourceLibraryFunc && editableOrNot" class="resourceLibraryFunc flex align spaceBetween">
                <!-- 批量上传 -->
                <img @click="resourcesBatchUpload" class="batchUpload pointer"
                  src="../../assets/resourceManagement/batchUpload.png" />
                <!-- 添加资源 -->
                <img @click="addResources" class="addResources pointer"
                  src="../../assets/resourceManagement/addResources.png" />
                <!-- 网页链接 -->
                <img @click="webLink" class="webLink pointer" src="../../assets/resourceManagement/webLink.png" />
              </div>
              <!-- 资源库功能区部分结束 -->
              <!-- 习题库功能区部分开始 -->
              <div v-show="exerciseLibraryFunc && editableOrNot" class="exerciseLibraryFunc flex align spaceBetween">
                <!-- 批量上传 -->
                <img @click="exercisesBatchUpload" class="batchUpload pointer"
                  src="../../assets/resourceManagement/batchUpload.png" />
                <!-- 添加习题 -->
                <img @click="addExercises" class="addExercises pointer"
                  src="../../assets/resourceManagement/addExercises.png" />
              </div>
              <!-- 习题库功能区部分结束 -->
              <!-- 作业库功能区部分开始 -->
              <div v-show="testPaperLibraryFunc && editableOrNot" class="testPaperLibraryFunc flex align spaceBetween">
                <!-- 批量上传 -->
                <img @click="testPaperBatchUpload" class="batchUpload pointer"
                  src="../../assets/resourceManagement/batchUpload.png" />
                <!-- 添加作业 -->
                <img @click="addTestpaper" class="addTestpaper pointer"
                  src="../../assets/resourceManagement/addTestpaper.png" />
              </div>
              <!-- 作业库功能区部分结束 -->
            </div>
          </div>
          <div>
            <el-table :data="resourceList" @selection-change="changeFun" :row-style="{ height: '0.3rem' }" fit
              height="calc(100vh - 2rem)">
              <el-table-column v-if="this.$route.params.method" type="selection" width="55"> </el-table-column>
              <el-table-column show-overflow-tooltip align="center" :prop="firstColumnName" :label="firstColumn">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="types" label="类型"> </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="created" label="上传时间"> </el-table-column>
              <el-table-column show-overflow-tooltip v-if="seat === 1" key="1" align="center" prop="num_item"
                label="题目数量"> </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="classLevel" label="所属课次"> </el-table-column>
              <el-table-column show-overflow-tooltip v-if="seat === 2" key="2" align="center" prop="usage" label="位置">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" prop="score" label="分值"> </el-table-column>
              <el-table-column v-if="editableOrNot" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                  <div @click="revise(scope.$index)" class="reviseTxt pointer">修改</div>
                </template>
              </el-table-column>
              <el-table-column v-if="!editableOrNot" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                  <el-button @click="revise(scope.$index)" type="text" icon="el-icon-view">查看</el-button>
                </template>
              </el-table-column>
              <el-table-column v-if="editableOrNot" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                  <img @click="deleteResources(scope.$index)" class="btnDelete pointer"
                    src="../../assets/resourceManagement/btnDelete.png" />
                </template>
              </el-table-column>
            </el-table>
            <el-pagination class="pagination" background @current-change="handleCurrentChange"
              :current-page.sync="currentPage" :page-size="10" layout="total, prev, pager, next" :total="allSize">
            </el-pagination>
            <!-- 资源列表部分结束 -->
            <div v-if="this.$route.params.method" @click="btnUploadAffirm" class="btnUploadAffirm pointer">确认</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 删除资源弹窗部分开始 -->
    <div v-show="showDeleteResources" class="pop-deleteResources">
      <div class="deleteResources">
        <img @click="showDeleteResources = false" class="btnClose pointer" src="../../assets/btnClose.png" />
        <div class="deleteResourcesTxt">删除后课程中将无法继续使用此资源，确定要将删除吗？</div>
        <div @click="btnAffirm" class="btnAffirm pointer">确认</div>
      </div>
    </div>
    <!-- 删除资源弹窗部分结束 -->
    <!-- 添加作业弹窗部分开始 -->
    <div v-show="showAddTestPaper" class="pop-deleteResources">
      <div class="deleteResources flex column align">
        <img @click="showAddTestPaper = false" class="btnClose pointer" src="../../assets/btnClose.png" />
        <div class="addTestPaper-title">请选择组题方式</div>
        <div class="topicSelection flex justify spaceBetween">
          <img class="manualTopicSelection pointer" ref="imgSelectedTopic1" @click="manualTopicSelection"
            src="../../assets/greyManualTopicSelection.png" />
          <img class="automaticTopicSelection pointer" ref="imgSelectedTopic2" @click="automaticTopicSelection"
            src="../../assets/greyAutomaticTopicSelection.png" />
        </div>
      </div>
    </div>
    <!-- 添加作业弹窗部分结束 -->
    <!-- 资源批量上传弹窗部分开始 -->
    <div v-show="showResourcesBatchUpload" class="pop-batchUpload">
      <div v-loading="loading" element-loading-text="拼命上传中..." element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.7)" class="resourcesBatchUpload-content">
        <img @click="showResourcesBatchUpload = false" class="btnClose pointer" src="../../assets/btnClose.png" />
        <div class="batchUpload-title">资源上传</div>
        <div class="flex spaceBetween" style="margin-top: 23px">
          <div></div>
          <img @click="templateDownload('资源')" class="templateDownload pointer"
            src="@/assets/classManagement/cm6.png" />
        </div>
        <!-- 所属课次 -->
        <div class="flex align justify spaceBetween" style="margin-top: 10px">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">所属课次:</div>
          </div>
          <div class="main-content-right">
            <van-popover close-on-click-outside placement="bottom-start" v-model="showPopoverResourcesBatchUpload">
              <div class="selectClass-box">
                <van-checkbox-group style="margin-top: 20px" v-for="(item, index) in allListClasses" :key="index"
                  v-model="checked">
                  <van-checkbox @click="changeCheckbox(item.name, item.id)" :name="item.name">课次 {{ index + 1 }} {{
              item.name }}</van-checkbox>
                </van-checkbox-group>
              </div>
              <template #reference>
                <div @click="showPopoverResourcesBatchUpload = true" class="publicInput-box flex align spaceBetween">
                  <input v-model="checked" disabled class="publicInput" type="text" placeholder="请选择所属课次" />
                  <img @click="showPopoverResourcesBatchUpload = true" style="margin-right: 17px"
                    src="../../assets/courseInformation/add.png" />
                </div>
              </template>
            </van-popover>
          </div>
        </div>
        <!-- 表格上传 -->
        <div class="flex spaceBetween" style="margin-top: 20px">
          <div class="flex">
            <div class="requiredIcon" style="opacity: 0">*</div>
            <div class="informationTxt">表格上传:</div>
          </div>
          <div class="main-content-right">
            <div class="upload-box">
              <img class="upload-img pointer" @click="btnResourcesFormImport" src="@/assets/classManagement/cm7.png" />
              <div v-show="showResourcesFormImport" class="submitSuccessfully flex align justify">
                <img class="submitSuccessfullyImg" src="@/assets/submitSuccessfully.png" />
              </div>
            </div>
          </div>
        </div>
        <!-- 资源上传 -->
        <div class="flex spaceBetween" style="margin-top: 20px">
          <div class="flex">
            <div class="requiredIcon" style="opacity: 0">*</div>
            <div class="informationTxt">资源上传:</div>
          </div>
          <div class="main-content-right">
            <div class="upload-box">
              <img class="upload-img pointer" @click="btnResourcesZipImport" src="@/assets/classManagement/cm7.png" />
              <div v-show="showResourcesZipImport" class="submitSuccessfully flex align justify">
                <img class="submitSuccessfullyImg" src="@/assets/submitSuccessfully.png" />
              </div>
            </div>
            <div class="informationTips">资源文件需上传压缩包，压缩包格式为Rar或zip。</div>
          </div>
        </div>
        <div class="flex justify pointer" style="margin-top: 17px">
          <div @click="btnResourcesPopAffirm" class="btnPopAffirm">确认</div>
        </div>
      </div>
    </div>
    <!-- 资源批量上传弹窗部分结束 -->
    <!-- 习题批量上传弹窗部分开始 -->
    <div v-show="showExercisesBatchUpload" class="pop-batchUpload">
      <div v-loading="loading" element-loading-text="拼命上传中..." element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.7)" class="resourcesBatchUpload-content">
        <img @click="showExercisesBatchUpload = false" class="btnClose pointer" src="../../assets/btnClose.png" />
        <div class="batchUpload-title">习题上传</div>
        <div class="flex spaceBetween" style="margin-top: 23px">
          <div></div>
          <img @click="templateDownload('习题')" class="templateDownload pointer"
            src="@/assets/classManagement/cm6.png" />
        </div>
        <!-- 所属课次 -->
        <div class="flex align justify spaceBetween" style="margin-top: 10px">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">所属课次:</div>
          </div>
          <div class="main-content-right">
            <van-popover close-on-click-outside placement="bottom-start" v-model="showPopoverExercisesBatchUpload">
              <div class="selectClass-box">
                <van-checkbox-group style="margin-top: 20px" v-for="(item, index) in allListClasses" :key="index"
                  v-model="checked">
                  <van-checkbox @click="changeCheckbox(item.name, item.id)" :name="item.name">课次 {{ index + 1 }} {{
              item.name }}</van-checkbox>
                </van-checkbox-group>
              </div>
              <template #reference>
                <div @click="showPopoverExercisesBatchUpload = true" class="publicInput-box flex align spaceBetween">
                  <input v-model="checked" disabled class="publicInput" type="text" placeholder="请选择所属课次" />
                  <img @click="showPopoverExercisesBatchUpload = true" style="margin-right: 17px"
                    src="../../assets/courseInformation/add.png" />
                </div>
              </template>
            </van-popover>
          </div>
        </div>
        <!-- 表格上传 -->
        <div class="flex spaceBetween" style="margin-top: 20px">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">表格上传:</div>
          </div>
          <div class="main-content-right">
            <div class="upload-box">
              <img class="upload-img pointer" @click="btnExercisesImport" src="@/assets/classManagement/cm7.png" />
              <div v-show="showExamitemFormImport" class="submitSuccessfully flex align justify">
                <img class="submitSuccessfullyImg" src="@/assets/submitSuccessfully.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify pointer" style="margin-top: 17px">
          <div @click="btnPopAffirm" class="btnPopAffirm">确认</div>
        </div>
      </div>
    </div>
    <!-- 习题批量上传弹窗部分结束 -->
    <!-- 作业批量上传弹窗部分开始 -->
    <div v-show="showTestPaperBatchUpload" class="pop-batchUpload">
      <div v-loading="loading" element-loading-text="拼命上传中..." element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.7)" class="resourcesBatchUpload-content">
        <img @click="showTestPaperBatchUpload = false" class="btnClose pointer" src="../../assets/btnClose.png" />
        <div class="batchUpload-title">作业上传</div>
        <div class="flex spaceBetween" style="margin-top: 23px">
          <div></div>
          <img @click="templateDownload('习题')" class="templateDownload pointer"
            src="@/assets/classManagement/cm6.png" />
        </div>
        <!-- 作业名称 -->
        <div class="flex align justify spaceBetween" style="margin-top: 10px">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">作业名称:</div>
          </div>
          <div class="main-content-right">
            <div class="publicInput-box flex align spaceBetween">
              <input v-model="testPaperName" class="publicInput" type="text" placeholder="请输入作业名称" />
            </div>
          </div>
        </div>
        <!-- 所属课次 -->
        <div class="flex align justify spaceBetween" style="margin-top: 10px">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">所属课次:</div>
          </div>
          <div class="main-content-right">
            <van-popover close-on-click-outside placement="bottom-start" v-model="showPopoverTestPaperBatchUpload">
              <div class="selectClass-box">
                <van-checkbox-group style="margin-top: 20px" v-for="(item, index) in allListClasses" :key="index"
                  v-model="checked">
                  <van-checkbox @click="changeCheckbox(item.name, item.id)" :name="item.name">课次 {{ index + 1 }} {{
              item.name }}</van-checkbox>
                </van-checkbox-group>
              </div>
              <template #reference>
                <div @click="showPopoverTestPaperBatchUpload = true" class="publicInput-box flex align spaceBetween">
                  <input v-model="checked" disabled class="publicInput" type="text" placeholder="请选择所属课次" />
                  <img @click="showPopoverTestPaperBatchUpload = true" style="margin-right: 17px"
                    src="../../assets/courseInformation/add.png" />
                </div>
              </template>
            </van-popover>
          </div>
        </div>
        <!-- 资源用途 -->
        <div class="flex align spaceBetween" style="margin-top: 10px">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">资源用途:</div>
          </div>
          <div class="main-content-right">
            <div class="useResources-box flex spaceBetween">
              <div @click="useResources = 'front'" class="flex align pointer">
                <div :class="this.useResources == 'front' ? 'selectUseCircle' : 'unSelectUseCircle'"></div>
                <div :class="this.useResources == 'front' ? 'selectUseTxt' : 'unSelectUseTxt'">课前</div>
              </div>
              <div @click="useResources = 'middle'" class="flex align pointer">
                <div :class="this.useResources == 'middle' ? 'selectUseCircle' : 'unSelectUseCircle'"></div>
                <div :class="this.useResources == 'middle' ? 'selectUseTxt' : 'unSelectUseTxt'">课中</div>
              </div>
              <div @click="useResources = 'back'" class="flex align pointer">
                <div :class="this.useResources == 'back' ? 'selectUseCircle' : 'unSelectUseCircle'"></div>
                <div :class="this.useResources == 'back' ? 'selectUseTxt' : 'unSelectUseTxt'">课后</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 表格上传 -->
        <div class="flex spaceBetween" style="margin-top: 20px">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">表格上传:</div>
          </div>
          <div class="main-content-right">
            <div class="upload-box">
              <img class="upload-img pointer" @click="btntestPaperImport" src="@/assets/classManagement/cm7.png" />
              <div v-show="showExamFormImport" class="submitSuccessfully flex align justify">
                <img class="submitSuccessfullyImg" src="@/assets/submitSuccessfully.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify pointer" style="margin-top: 17px">
          <div @click="btnPopAffirm" class="btnPopAffirm">确认</div>
        </div>
      </div>
    </div>
    <!-- 作业批量上传弹窗部分结束 -->
  </div>
</template>

<script>
import { resourceList, resourceAssociationDel, addTextbookSidebar, textbookGetCourse, courseTimesList } from "@/api";
import { base64toFile, filetoBase64 } from "@/utils/util.js";
import { Toast } from "vant";
import axios from "axios";
import store from "@/store";
export default {
  data() {
    return {
      editableOrNot: true, // 是否可编辑
      identity: "", // 登录身份
      checked: [], // 批量上传的课次名称列表
      loading: false,
      checkedClassNumberIDList: [], // 批量上传的课次id列表
      showDeleteResources: false, // 控制删除资源弹窗的显示
      currentClassesIdx: -1, // 当前选中的课次
      allListClasses: [], // 全部课次列表
      resourceList: [], // 资源列表
      uploadTime: "", // 上传时间
      blueResourcePool: require("../../assets/resourceManagement/blueResourcePool.png"), // 资源库图片
      greyExercisebank: require("../../assets/resourceManagement/greyExercisebank.png"), // 习题库图片
      greyTestpaperlibrary: require("../../assets/resourceManagement/greyTestpaperlibrary.png"), // 作业库图片
      resourceType: "assets", // 当前选中的什么库
      firstColumn: "资源名称", // 第一列表头文字
      resourceLibraryFunc: true, // 控制资源库功能区的显示
      exerciseLibraryFunc: false, // 控制资源库功能区的显示
      testPaperLibraryFunc: false, // 控制资源库功能区的显示
      seat: 2, // 控制位置列的显示
      firstColumnName: "name", // 第一列显示的文字
      showAddTestPaper: false, // 控制添加作业弹窗的显示
      showResourcesBatchUpload: false, // 控制资源批量上传弹窗的显示
      showExercisesBatchUpload: false, // 控制习题批量上传弹窗的显示
      showTestPaperBatchUpload: false, // 控制作业批量上传弹窗的显示
      showPopoverResourcesBatchUpload: false, // 控制资源批量上传课次下拉列表的显示
      showPopoverExercisesBatchUpload: false, // 控制习题批量上传课次下拉列表的显示
      showPopoverTestPaperBatchUpload: false, // 控制作业批量上传课次下拉列表的显示
      testPaperName: "", // 批量上传作业名称
      formFile: "", // 上传表格的Base64
      resourcesFile: "", // 上传资源的Base64
      useResources: "", // 批量上传选中的作业资源用途
      showResourcesFormImport: false, // 控制资源上传的表格上传成功提示的显示
      showResourcesZipImport: false, // 控制资源上传的资源上传成功提示的显示
      showExamitemFormImport: false, // 控制习题上传的成功提示的显示
      showExamFormImport: false, // 控制作业上传的成功提示的显示
      courseName: "", // 课次搜索的课次名称
      resourceName: "", // 资源搜索的资源名称
      multipleSelection: [], // 选中的题目数组
      courseOptions: [],
      courseId: "",
      currentPage: 1, // 当前页数
      allSize: 0, // 总条数
      classTimesNum: 0, // 当前选中课次id
    };
  },
  created() {
    this.courseId = this.$store.state.courseDetails.id;
    if (this.$store.state.textbookDetails) {
      // 调用根据教材获取课程接口
      let params1 = { book_id: this.$store.state.textbookDetails.id };
      textbookGetCourse(params1).then((res) => {
        if (res.data.datas != []) {
          let publicRes = res.data.datas;
          this.courseOptions = publicRes.map((item) => {
            return { value: item.id, label: item.name + "——" + item.user?.name };
          });
        }
      });
    }
    this.editableOrNot = this.$store.state.editableOrNot; // 获取是否可编辑状态
    // 获取登录身份
    this.identity = this.$store.state.loginRecord.data.datas.identity;
    // 获取当前课程全部课次的数据
    this.allListClasses = this.$store.state.classListRecord;
    this.classTimesNum = this.$store.state.classTimesId || 0; // 从store获取课次id
    // 根据classTimesId设置currentClassesIdx
    if (this.classTimesNum > 0 && this.allListClasses.length > 0) {
      const index = this.allListClasses.findIndex(item => item.id === this.classTimesNum);
      if (index !== -1) {
        this.currentClassesIdx = index;
      }
    }
    this.libraryList(this.resourceType);
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.classTimesNum == 0) {
        let params = {
          lesson_id: this.courseId,
          lesson_item_id: "",
          types: this.resourceType,
          page: val,
          num: 10,
          is_items: "true",
        };
        this.publicClassResources(params);
      } else {
        let params = {
          lesson_id: this.courseId,
          lesson_item_id: this.classTimesNum,
          types: this.resourceType,
          page: val,
          num: 10,
          is_items: "true",
        };
        this.publicClassResources(params);
      }
    },
    changeCourseOptions(e) {
      this.courseId = e;
      // 资源列表接口调取数据
      let params = {
        lesson_id: e,
        lesson_item_id: this.classTimesNum,
        types: this.resourceType,
        page: 1,
        num: 10,
        is_items: "true",
      };
      this.publicClassResources(params);
      // 获取课程课次
      let params1 = { lesson_id: e };
      courseTimesList(params1).then((res) => {
        this.$store.commit("GET_ClassListRecord", res.data.datas);
        this.allListClasses = this.$store.state.classListRecord;
      });
    },
    //复选框状态改变
    changeFun(val) {
      this.multipleSelection = val;
    },
    // 从教学资源库添加按钮
    btnUploadAffirm() {
      let idsString = this.multipleSelection.map((obj) => obj.link_resource_id).join(",");
      // 调用教材侧边资源关联添加接口
      let params = { link_resource_id: idsString, link_book_id: this.$route.params.link_book_id };
      addTextbookSidebar(params).then((res) => {
        if (res.data.code == 0) {
          Toast("上传成功！");
        }
      });
    },
    // 模版下载
    templateDownload(type) {
      var a = document.createElement("a");
      if (type == "资源") {
        a.href = window.location.protocol + "//school.striveing.com/web/template/资源导入模板.xlsx";
        a.download = "资源导入模板.xlsx";
      } else if (type == "习题") {
        a.href = window.location.protocol + "//school.striveing.com/web/template/课程习题导入模板.xlsx";
        a.download = "课程习题导入模板.xlsx";
      }
      document.body.appendChild(a);
      a.click();
    },
    // 课次搜索
    courseSearch(name) {
      this.allListClasses = [];
      for (let i = 0; i < this.$store.state.classListRecord.length; i++) {
        if (this.$store.state.classListRecord[i].name.indexOf(name) >= 0) {
          this.allListClasses.push(this.$store.state.classListRecord[i]);
        }
      }
    },
    // 资源搜索
    resourceSearch(name) {
      this.resourceList = [];
      if (this.resourceType == "examitem") {
        for (let i = 0; i < this.$store.state.resourceListRecord.length; i++) {
          if (this.$store.state.resourceListRecord[i].content.indexOf(name) >= 0) {
            this.resourceList.push(this.$store.state.resourceListRecord[i]);
          }
        }
      } else {
        for (let i = 0; i < this.$store.state.resourceListRecord.length; i++) {
          if (this.$store.state.resourceListRecord[i].name.indexOf(name) >= 0) {
            this.resourceList.push(this.$store.state.resourceListRecord[i]);
          }
        }
      }
    },
    // 资源库修改
    revise(idx) {
      if (this.resourceType == "assets") {
        if (this.resourceList[idx].types == "资源链接" || this.resourceList[idx].types == "特殊互动") {
          this.$router.push({
            name: "webLink",
            params: { record: this.resourceList[idx] },
          });
        } else {
          this.$router.push({
            name: "addResources",
            params: { record: this.resourceList[idx] },
          });
        }
      } else if (this.resourceType == "examitem") {
        this.$router.push({
          name: "addExercises",
          params: { record: this.resourceList[idx] },
        });
      } else if (this.resourceType == "exam") {
        this.$router.push({
          name: "addTestPaper",
          params: { method: "handMovement", record: this.resourceList[idx].id, emptyOrNot: true },
        });
      }
    },
    // 获取资源列表数据公共方法
    publicClassResources(params) {
      resourceList(params).then((res) => {
        let resourceList = [];
        this.allSize = res.data.ext;
        for (let i in res.data.datas) {
          if (this.resourceType == "assets") {
            if (res.data.datas[i].assets) {
              res.data.datas[i].assets.link_resource_id = res.data.datas[i].id;
              res.data.datas[i].assets.link_created = res.data.datas[i].created;
              res.data.datas[i].assets.lesson_item = res.data.datas[i].lesson_item;
              resourceList.push(res.data.datas[i].assets);
            }
          } else if (this.resourceType == "examitem") {
            if (res.data.datas[i].exam_item) {
              res.data.datas[i].exam_item.link_resource_id = res.data.datas[i].id;
              res.data.datas[i].exam_item.link_created = res.data.datas[i].created;
              res.data.datas[i].exam_item.lesson_item = res.data.datas[i].lesson_item;
              resourceList.push(res.data.datas[i].exam_item);
            }
          } else if (this.resourceType == "exam") {
            if (res.data.datas[i].exam) {
              res.data.datas[i].exam.link_resource_id = res.data.datas[i].id;
              res.data.datas[i].exam.link_created = res.data.datas[i].created;
              res.data.datas[i].exam.lesson_item = res.data.datas[i].lesson_item;
              resourceList.push(res.data.datas[i].exam);
            }
          }
        }
        this.$store.commit("GET_ResourceListRecord", resourceList); // 提交资源列表到store
        for (let i in resourceList) {
          let publicRes = resourceList[i];
          publicRes.created = publicRes.link_created.substring(0, 10); // 上传日期
          publicRes.score = publicRes.score + "分"; // 分值
          // 所属课次
          publicRes.classLevel = "";
          for (let j = 0; j < publicRes.lesson_items.length; j++) {
            for (let i = 0; i < this.allListClasses.length; i++) {
              if (this.currentClassesIdx == -1) {
                if (this.allListClasses[i].name == publicRes.lesson_items[j]?.name) {
                  publicRes.classLevel += "          课次" + (i + 1) + "." + publicRes.lesson_items[j]?.name;
                }
              } else {
                if (this.allListClasses[i].name == publicRes.lesson_items[j].name) {
                  publicRes.classLevel = "          课次" + (i + 1) + "." + publicRes.lesson_items[j]?.name;
                }
              }
            }
          }
          // 资源名称
          if (this.firstColumnName == "content") {
            resourceList[i].content = resourceList[i].content.replace(/<[^>]+>/g, "");
          }
          // 类型
          if (publicRes.types == "video") {
            publicRes.types = "视频资源";
          } else if (publicRes.types == "audio") {
            publicRes.types = "音频资源";
          } else if (publicRes.types == "doc") {
            publicRes.types = "文档资源";
          } else if (publicRes.types == "image") {
            publicRes.types = "图片资源";
          } else if (publicRes.types == "web") {
            publicRes.types = "资源链接";
          } else if (publicRes.types == "h5") {
            publicRes.types = "特殊互动";
          } else if (publicRes.types == "single") {
            publicRes.types = "单选题";
          } else if (publicRes.types == "multi") {
            publicRes.types = "多选题";
          } else if (publicRes.types == "truefalse") {
            publicRes.types = "判断题";
          } else if (publicRes.types == "answer") {
            publicRes.types = "简答题";
          } else if (publicRes.types == "blank") {
            publicRes.types = "填空题";
          } else if (publicRes.types == "manual") {
            publicRes.types = "作业-手动";
          } else if (publicRes.types == "auto") {
            publicRes.types = "作业-自动";
          }
          // 位置
          if (publicRes.usage == "front") {
            publicRes.usage = "课前";
          } else if (publicRes.usage == "middle") {
            publicRes.usage = "课中";
          } else if (publicRes.usage == "back") {
            publicRes.usage = "课后";
          }
        }
        this.resourceList = resourceList;
      });
    },
    // 切换库获取资源列表数据公共方法
    switchLibrary() {
      if (this.classTimesNum == 0) {
        // 资源列表接口调取数据
        let params = {
          lesson_id: this.courseId,
          lesson_item_id: "",
          types: this.resourceType,
          page: 1,
          num: 10,
          is_items: "true",
        };
        this.publicClassResources(params);
      } else {
        // 资源列表接口调取数据
        let params = {
          lesson_id: this.courseId,
          lesson_item_id: this.classTimesNum,
          types: this.resourceType,
          page: 1,
          num: 10,
          is_items: "true",
        };
        this.publicClassResources(params);
      }
    },
    // 当前选择的什么库
    libraryList(idx) {
      this.currentPage = 1;
      this.multipleSelection = [];
      this.resourceType = idx;
      if (idx == "assets") {
        this.blueResourcePool = require("../../assets/resourceManagement/blueResourcePool.png");
        this.greyExercisebank = require("../../assets/resourceManagement/greyExercisebank.png");
        this.greyTestpaperlibrary = require("../../assets/resourceManagement/greyTestpaperlibrary.png");
        this.firstColumn = "资源名称"; // 第一列表头文字
        this.resourceLibraryFunc = true; // 控制资源库功能区的显示
        this.exerciseLibraryFunc = false; // 控制资源库功能区的显示
        this.testPaperLibraryFunc = false; // 控制资源库功能区的显示
        this.seat = 2; // 控制位置列的显示
        this.firstColumnName = "name"; // 第一列显示的文字
        // 调取切换库获取资源列表数据公共方法
        this.switchLibrary();
      } else if (idx == "examitem") {
        this.blueResourcePool = require("../../assets/resourceManagement/greyResourcePool.png");
        this.greyExercisebank = require("../../assets/resourceManagement/blueExercisebank.png");
        this.greyTestpaperlibrary = require("../../assets/resourceManagement/greyTestpaperlibrary.png");
        this.firstColumn = "题干"; // 第一列表头文字
        this.resourceLibraryFunc = false; // 控制资源库功能区的显示
        this.exerciseLibraryFunc = true; // 控制资源库功能区的显示
        this.testPaperLibraryFunc = false; // 控制资源库功能区的显示
        this.seat = 2; // 控制位置列的显示
        this.firstColumnName = "content"; // 第一列显示的文字
        // 调取切换库获取资源列表数据公共方法
        this.switchLibrary();
      } else if (idx == "exam") {
        this.blueResourcePool = require("../../assets/resourceManagement/greyResourcePool.png");
        this.greyExercisebank = require("../../assets/resourceManagement/greyExercisebank.png");
        this.greyTestpaperlibrary = require("../../assets/resourceManagement/blueTestpaperlibrary.png");
        this.firstColumn = "作业名称"; // 第一列表头文字
        this.resourceLibraryFunc = false; // 控制资源库功能区的显示
        this.exerciseLibraryFunc = false; // 控制资源库功能区的显示
        this.testPaperLibraryFunc = true; // 控制资源库功能区的显示
        this.seat = 1; // 控制位置列的显示
        this.firstColumnName = "name"; // 第一列显示的文字
        // 调取切换库获取资源列表数据公共方法
        this.switchLibrary();
      }
    },
    // 选中全部课次的逻辑
    allClasses() {
      this.currentPage = 1;
      this.currentClassesIdx = -1;
      this.classTimesNum = 0; // 恢复课次id
      // 资源列表接口调取数据
      let params = {
        lesson_id: this.courseId,
        lesson_item_id: "",
        types: this.resourceType,
        page: this.currentPage,
        num: 10,
        is_items: "true",
      };
      this.publicClassResources(params);
    },
    // 选中单个课次的逻辑
    singleClass(idx) {
      this.currentPage = 1;
      this.currentClassesIdx = idx;
      // 资源列表接口调取数据
      this.classTimesNum = this.allListClasses[idx].id;
      // 将选中的课次ID存储到store中，以便在addResources页面使用
      this.$store.commit('GET_ClassTimesId', this.classTimesNum);
      let params = {
        lesson_id: this.courseId,
        lesson_item_id: this.classTimesNum,
        types: this.resourceType,
        page: this.currentPage,
        num: 10,
        is_items: "true",
      };
      this.publicClassResources(params);
    },
    // 添加资源
    addResources() {
      this.$router.push("/addResources");
    },
    // 网页链接
    webLink() {
      this.$router.push("/webLink");
    },
    // 添加习题
    addExercises() {
      this.$router.push("/addExercises");
    },
    // 添加作业
    addTestpaper() {
      this.showAddTestPaper = true;
    },
    // 删除资源
    deleteResources(idx) {
      let recordID = this.$store.state.resourceListRecord[idx];
      this.$store.commit("GET_classTimesResources", recordID); // 提交资源id到store
      this.showDeleteResources = true;
    },
    // 删除资源弹窗确认按钮调取删除资源接口并关闭弹窗
    btnAffirm() {
      let resourcesRes = this.$store.state.classTimesResources;
      let data = { link_resource_id: resourcesRes.link_resource_id };
      resourceAssociationDel(data).then((res) => {
        if (res.data.code == 0) {
          this.showDeleteResources = false;
          Toast("已删除！");
          // 资源列表接口调取数据
          if (this.currentClassesIdx == -1) {
            let params = {
              lesson_id: this.courseId,
              lesson_item_id: "",
              types: this.resourceType,
              page: this.currentPage,
              num: 10,
              is_items: "true",
            };
            this.publicClassResources(params);
          } else {
            let params = {
              lesson_id: this.courseId,
              lesson_item_id: this.allListClasses[this.currentClassesIdx].id,
              types: this.resourceType,
              page: this.currentPage,
              num: 10,
            };
            this.publicClassResources(params);
          }
        }
      });
    },
    // 手动选题
    manualTopicSelection() {
      this.$refs.imgSelectedTopic1.src = require("../../assets/blueManualTopicSelection.png");
      this.$refs.imgSelectedTopic2.src = require("../../assets/greyAutomaticTopicSelection.png");
      this.$router.push({
        name: "addTestPaper",
        params: { method: "handMovement", emptyOrNot: true },
      });
    },
    // 自动选题
    automaticTopicSelection() {
      this.$refs.imgSelectedTopic1.src = require("../../assets/greyManualTopicSelection.png");
      this.$refs.imgSelectedTopic2.src = require("../../assets/blueAutomaticTopicSelection.png");
      this.$router.push({
        name: "addTestPaper",
        params: { method: "voluntarily" },
      });
    },
    // 更改资源所属课次
    changeCheckbox(className, idx) {
      this.checked = [];
      this.checked.push(className);
      this.checkedClassNumberIDList = [];
      this.checkedClassNumberIDList.push(idx);
    },

    // 资源批量上传
    resourcesBatchUpload() {
      this.showResourcesBatchUpload = true;
      this.formFile = ""; // 清空资源表格上传的文件路径
      this.resourcesFile = ""; // 清空资源zip上传的文件路径
      this.checked = []; // 清空资源上传的所属课次名称
      this.checkedClassNumberIDList = []; // 清空资源上传的所属课次id
      this.showResourcesFormImport = false;
      this.showResourcesZipImport = false;
    },

    // 资源表格导入
    btnResourcesFormImport() {
      let input = document.createElement("input"); // 创建一个input标签
      document.body.appendChild(input);
      input.style.display = "none";
      input.type = "file"; // 类型改成file 上传文件
      input.accept = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"; // 接受类型
      input.click(); // 触发点击事件 调起文件夹
      input.onchange = (event) => {
        if (!event.target.files || !event.target.files[0]) {
          reject("未选择文件");
        } else {
          this.formFile = event.target.files[0]; // 文件路径
          this.showResourcesFormImport = true;
        }
      };
    },

    // 资源压缩包导入
    btnResourcesZipImport() {
      let input = document.createElement("input"); // 创建一个input标签
      document.body.appendChild(input);
      input.style.display = "none";
      input.type = "file"; // 类型改成file 上传文件
      input.accept = "*"; // 接受类型
      input.click(); // 触发点击事件 调起文件夹
      input.onchange = (event) => {
        if (!event.target.files || !event.target.files[0]) {
          reject("未选择文件");
        } else {
          this.resourcesFile = event.target.files[0]; // 文件路径
          this.showResourcesZipImport = true;
        }
      };
    },

    // 资源批量上传确定按钮
    btnResourcesPopAffirm() {
      if (this.checkedClassNumberIDList.length == 0) {
        Toast("请选择课次！");
      } else if (!this.formFile) {
        Toast("请上传表格或资源！");
      } else {
        this.loading = true;
        let formData = new FormData();
        if (this.formFile) {
          formData.append("file", this.formFile); // 加入表格文件流参数
        }
        if (this.resourcesFile) {
          formData.append("zip", this.resourcesFile); // 加入zip文件流参数
        }
        formData.append("lesson_item_id", this.checkedClassNumberIDList[0]); // 加入课次id参数
        axios
          .post(store.state.interfacePath + "api/import/assets", formData, {
            headers: {
              "user-token": this.$store.state.loginRecord.data.ext,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let res = response.data;
            if (res.code == 0) {
              this.loading = false;
              this.showResourcesBatchUpload = false;
              Toast("已上传:" + res.ext.insert + "   " + "已更新:" + res.ext.update);
              let params = {
                lesson_id: this.courseId,
                lesson_item_id: this.classTimesNum,
                types: this.resourceType,
                page: this.currentPage,
                num: 10,
              };
              this.publicClassResources(params);
            } else {
              this.loading = false;
              Toast("上传失败！");
            }
          })
          .catch((response) => { });
      }
    },

    // 习题批量上传
    exercisesBatchUpload() {
      this.showExercisesBatchUpload = true;
      this.formFile = ""; // 清空习题上传的文件路径
      this.checked = []; // 清空习题上传的所属课次名称
      this.checkedClassNumberIDList = []; // 清空习题上传的所属课次id
      this.showExamitemFormImport = false;
    },

    // 习题表格导入
    btnExercisesImport() {
      let input = document.createElement("input"); // 创建一个input标签
      document.body.appendChild(input);
      input.style.display = "none";
      input.type = "file"; // 类型改成file 上传文件
      input.accept = "*"; // 接受类型
      input.click(); // 触发点击事件 调起文件夹
      input.onchange = (event) => {
        if (!event.target.files || !event.target.files[0]) {
          reject("未选择文件");
        } else {
          this.formFile = event.target.files[0]; // 文件路径
          this.showExamitemFormImport = true;
        }
      };
    },

    // 作业批量上传
    testPaperBatchUpload() {
      this.showTestPaperBatchUpload = true;
      this.formFile = ""; // 清空作业上传的文件路径
      this.testPaperName = ""; // 清空作业上传的作业名称
      this.useResources = ""; // 清空作业上传的所属用途
      this.checked = []; // 清空作业上传的所属课次名称
      this.checkedClassNumberIDList = []; // 清空作业上传的所属课次id
      this.showExamFormImport = false;
    },

    // 作业表格导入
    btntestPaperImport() {
      let input = document.createElement("input"); // 创建一个input标签
      document.body.appendChild(input);
      input.style.display = "none";
      input.type = "file"; // 类型改成file 上传文件
      input.accept = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"; // 接受类型
      input.click(); // 触发点击事件 调起文件夹
      input.onchange = (event) => {
        if (!event.target.files || !event.target.files[0]) {
          reject("未选择文件");
        } else {
          this.formFile = event.target.files[0]; // 文件路径
          this.showExamFormImport = true;
        }
      };
    },

    // 批量上传确定按钮
    btnPopAffirm() {
      if (this.showTestPaperBatchUpload == true && this.testPaperName == "") {
        Toast("请上传作业名称！");
      } else if (this.checkedClassNumberIDList.length == 0) {
        Toast("请选择课次！");
      } else if (this.showTestPaperBatchUpload == true && this.useResources == "") {
        Toast("请选择资源用途！");
      } else if (!this.formFile) {
        Toast("请上传表格！");
      } else {
        this.loading = true;
        let formData = new FormData();
        formData.append("file", this.formFile); // 加入文件流参数
        formData.append("lesson_item_id", this.checkedClassNumberIDList[0]); // 加入课次id参数
        if (this.showTestPaperBatchUpload) {
          formData.append("exam_name", this.testPaperName); // 加入作业名称参数
          formData.append("usage", this.useResources); // 加入所属课次参数
        }
        axios
          .post(store.state.interfacePath + "api/import/exam_item", formData, {
            headers: {
              "user-token": this.$store.state.loginRecord.data.ext,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let res = response.data;
            if (res.code == 0) {
              this.loading = false;
              this.showResourcesBatchUpload = false;
              this.showExercisesBatchUpload = false;
              this.showTestPaperBatchUpload = false;
              Toast("已上传:" + res.ext.insert + "   " + "已更新:" + res.ext.update);
              let params = {
                lesson_id: this.courseId,
                lesson_item_id: this.classTimesNum,
                types: this.resourceType,
                page: this.currentPage,
                num: 10,
              };
              this.publicClassResources(params);
            } else {
              this.loading = false;
              Toast("上传失败！");
            }
          })
          .catch((response) => { });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}

.flex {
  display: flex;
}

.column {
  flex-direction: column;
}

.align {
  align-items: center;
}

.justify {
  justify-content: center;
}

.spaceBetween {
  justify-content: space-between;
}

.box {
  width: 100%;
  height: 100%;
  display: flex;
}

.main-content {
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  display: flex;
}

/* 课次列表部分 */
.searchIcon {
  width: 25px;
  height: 25px;
}

.classTimesList {
  width: 466px;
  height: 100%;
  border-right: 1px solid #bfbfbf;
}

.classTimesList-block {
  width: 12px;
  height: 26px;
  background: #3096fb;
}

.courseSearch-content {
  padding: 20px 30px;
  box-sizing: border-box;
}

.courseSearch-box {
  width: 406px;
  height: 45px;
  border: 1px solid #dddddd;
  border-radius: 23px;
  padding: 0 27px;
  box-sizing: border-box;
}

.courseSearch {
  width: 300px;
  font-size: 18px;

  font-weight: 400;
  color: #999999;
  background-color: transparent;
  border: 0px;
  outline: none;
}

.classTimesList-title-box {
  margin-bottom: 2px;
  background: rgba(52, 154, 254, 0.25);
  padding: 17px 20px;
  box-sizing: border-box;
}

.classTimesList-title {
  margin-left: 20px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.classList-box {
  height: calc(100vh - 330px);
  overflow: scroll;
}

.allClasses {
  background: #eaeaea;
  padding: 16px 31px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.classList-circle {
  width: 10px;
  height: 10px;
  background: #3096fb;
  border-radius: 50%;
}

.classList-num {
  margin-left: 22px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.classList-name {
  width: 300px;
  margin-left: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

/* 课次列表 */
.classList {
  padding: 16px 31px;
  background: #ffffff;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.classList:hover {
  background: #eaeaea;
}

/* 资源库 习题库 作业库部分 */
.resourcesList {
  display: flex;
  flex-direction: column;
}

.libraryListTop {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1273px;
  padding: 23px 0;
  border-bottom: 1px solid #bfbfbf;
}

.libraryList-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 248px;
  height: 40px;
  cursor: pointer;
}

.resourceLibraryFunc {
  width: 385px;
}

.exerciseLibraryFunc {
  width: 249px;
}

.testPaperLibraryFunc {
  width: 249px;
}

.resourcePool {
  width: 112px;
  height: 24px;
}

.exercisebank {
  width: 110px;
  height: 24px;
}

.testpaperlibrary {
  width: 109px;
  height: 24px;
}

.batchUpload {
  width: 112px;
  height: 20px;
}

.addResources {
  width: 108px;
  height: 18px;
}

.webLink {
  width: 108px;
  height: 20px;
}

.addExercises {
  width: 108px;
  height: 18px;
}

.addTestpaper {
  width: 108px;
  height: 18px;
}

.resourcesContent {
  margin-bottom: 20px;
  position: relative;
  width: 100%;
  height: 100%;
  padding: 20px 30px;
  box-sizing: border-box;
}

.inputSearch-box {
  margin-right: 20px;
  width: 406px;
  height: 40px;
  border: 1px solid #dddddd;
  border-radius: 23px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 27px;
}

.inputSearch {
  width: 300px;
  font-size: 18px;

  font-weight: 400;
  color: #999999;
  background-color: transparent;
  border: 0px;
  outline: none;
}

/* 自定义placeholder的默认样式 */
input::-webkit-input-placeholder {
  color: #666666;
}

.resourceFunction {
  height: 51px;
  padding: 0 20px;
  box-sizing: border-box;
}

.arrangeBy-txt {
  font-size: 18px;
  font-weight: 400;
  color: #000000;
}

.gaugeOutfit {
  width: 100%;
  padding: 0 20px;
  height: 51px;
  box-sizing: border-box;
  border-bottom: 1px solid #bfbfbf;
}

.gaugeOutfit-txt {
  font-size: 18px;

  font-weight: 400;
  color: #666666;
}

/* 资源列表 */
.resourceList {
  width: 100%;
  height: 51px;
  padding: 0 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #bfbfbf;
}

.resourceList-name {
  width: 303px;
  height: 21px;
  line-height: 21px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resourceList-type {
  width: 110px;
  height: 21px;
  border-left: 1px solid #000000;
  border-right: 1px solid #000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resourceList-time {
  width: 128px;
  height: 21px;
  border-right: 1px solid #000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resourceList-classTime {
  width: 373px;
  height: 21px;
  align-items: center;
  padding-left: 5px;
  line-height: 21px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resourceList-seat {
  width: 62px;
  height: 21px;
  border-left: 1px solid #000000;
  border-right: 1px solid #000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resourceList-score {
  width: 62px;
  height: 21px;
  padding-left: 12px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

/* 删除课程弹窗 */
.pop-deleteResources {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 101;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.deleteResources {
  position: relative;
  width: 761px;
  height: 300px;
  background: #ffffff;
  border-radius: 20px;
}

.btnClose {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 23px;
  height: 23px;
}

.deleteResourcesTxt {
  position: absolute;
  width: 550px;
  height: 83px;
  font-size: 30px;

  font-weight: 400;
  color: #000000;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.btnAffirm {
  position: absolute;
  width: 200px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 28px;

  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
  top: 217px;
  left: 50%;
  transform: translateX(-50%);
}

.addTestPaper-title {
  font-size: 26px;

  font-weight: 400;
  color: #349afe;
  text-align: center;
  margin-top: 31px;
}

.topicSelection {
  margin-top: 38px;
  width: 488px;
}

.manualTopicSelection {
  width: 200px;
  height: 160px;
}

.automaticTopicSelection {
  width: 200px;
  height: 160px;
}

.reviseTxt {
  font-size: 20px;

  font-weight: 400;
  color: #349afe;
}

/* 批量上传弹窗 */
.pop-batchUpload {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 101;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.resourcesBatchUpload-content {
  position: relative;
  width: 761px;
  background: #ffffff;
  border-radius: 20px;
  padding: 22px 56px;
  box-sizing: border-box;
}

.batchUpload-title {
  font-size: 26px;

  font-weight: 400;
  color: #349afe;
  text-align: center;
}

.templateDownload {
  width: 107px;
  height: 19px;
}

.requiredIcon {
  width: 10px;
  height: 10px;
  color: #ff0000;
}

.informationTxt {
  font-size: 22px;

  font-weight: 400;
  color: #555555;
}

.selectClass-box {
  width: 491px;
  max-height: 300px;
  padding: 0px 20px 20px 20px;
  box-sizing: border-box;
  overflow: scroll;
}

.main-content-right {
  width: 491px;
  margin-left: 35px;
}

/* 公共输入框样式 */
.publicInput-box {
  width: 491px;
  height: 50px;
  border: 1px solid #757575;
  border-radius: 10px;
}

.publicInput {
  font-size: 20px;

  font-weight: 400;
  color: #555555;
  margin-left: 17px;
  width: 491px;
  height: 50px;
  border: 1px solid #757575;
  border-radius: 10px;
  background-color: transparent;
  border: 0px;
  outline: none;
}

/* 自定义placeholder的默认样式 */
input::-webkit-input-placeholder {
  color: #666666;
}

.informationTips {
  font-size: 16px;

  font-weight: 400;
  color: #b6b6b6;
}

.btnPopAffirm {
  width: 200px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 28px;

  font-weight: 400;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.selectUseCircle {
  width: 12px;
  height: 12px;
  background: #349afe;
  border-radius: 50%;
}

.unSelectUseCircle {
  width: 8px;
  height: 8px;
  border: 2px solid #b8b8b8;
  border-radius: 50%;
}

.selectUseTxt {
  margin-left: 6px;
  font-size: 20px;

  font-weight: 400;
  color: #349afe;
}

.unSelectUseTxt {
  margin-left: 6px;
  font-size: 20px;

  font-weight: 400;
  color: #b9b9b9;
}

.submitSuccessfully {
  position: absolute;
  top: 0;
  width: 135px;
  height: 95px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.5);
  pointer-events: none;
}

.btnDelete {
  width: 68px;
  height: 20px;
}

.upload-box {
  position: relative;
  width: 135px;
  height: 95px;
}

.upload-img {
  width: 135px;
  height: 95px;
}

.submitSuccessfullyImg {
  width: 40px;
  height: 40px;
}

.useResources-box {
  width: 262px;
}

.btnUploadAffirm {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 200px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 28px;

  font-weight: 400;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination {
  margin-top: 20px;
}
</style>
